import * as Constants from "../common/constants";
import { IController } from "../interfaces/controller";
import * as Data from "../interfaces/data";

import * as UI from "../common/ui";
import * as UserProfileData from "../data/userProfileData";
import * as Translations from "../interfaces/translations";

import * as ko from "knockout";

// For UserProfile page
const USERPROFILE_MISSING_TIMEZONEID = "Please select a Time Zone.";

interface IUserProfileViewModel {
    TimeZoneID: KnockoutObservable<number>;
    LanguageID: KnockoutObservable<number>;
    TimeZones: KnockoutObservableArray<Data.ICodeModel<number>>;
    Languages: KnockoutObservableArray<Translations.ILanguage>;
}

export class UserProfileController implements IController {
    // references to DOM elements
    private container: JQuery;
    private viewModel: IUserProfileViewModel;
    private fieldsOnLoad: string = "";

    constructor() {

        this.viewModel = {
            TimeZoneID: ko.observable<number>(),
            LanguageID: ko.observable<number>(),
            TimeZones: ko.observableArray<Data.ICodeModel<number>>(),
            Languages: ko.observableArray<Translations.ILanguage>([]),
        };

    }

    public render(container: JQuery): JQueryPromise<any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        this.container = container;

        ko.applyBindings(this.viewModel, container[0]);

        deferred.resolve();
        return deferred.promise();
    }

    public load(): JQueryPromise<any> {

        return this.loadRecord();
    }

    public haveFieldsChanged(): boolean {
        const fieldValues: string = JSON.stringify(this.createUserProfileMaster());
        return fieldValues !== this.fieldsOnLoad;
    }

    public appRouterID(params: string[]): string {
        return "UserProfile";
    }

    public save(): JQueryPromise<any> {
        let waitContainer: JQuery;
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        if (this.isValid()) {
            waitContainer = UI.showWaitIndicator(this.container);
            UserProfileData.SaveUserProfileMaster(this.createUserProfileMaster())
                .done((response: Data.IResponse<boolean>) => {
                    if (response.Success) {
                        UI.showNotificationMessage(Constants.PHRASE_RECORDSAVED, UI.messageTypeValues.success);
                        this.fieldsOnLoad = JSON.stringify(this.createUserProfileMaster());
                        deferred.resolve();
                    } else {
                        UI.showErrorMessage(response.ErrorMessages);
                        deferred.reject();
                    }
                })
                .fail(() => {
                    deferred.reject();
                })
                .always(() => {
                    UI.hideWaitIndicator(this.container, waitContainer);
                });
        } else {
            // not all valid fields are entered
            deferred.reject();
        }

        return deferred.promise();
    }

    // returns a title for the page
    public title(): string {
        return "Your Profile";
    }
    public subTitle(): string {
        return "";
    }

    private loadRecord(): JQueryPromise<any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();
        const waitContainer: JQuery<HTMLElement> = UI.showWaitIndicator(this.container);
        const me: UserProfileController = this;

        UserProfileData.GetUserProfileMaster()
            .done((response: Data.IResponse<UserProfileData.IUserProfileMaster>) => {
                if (response.Success) {
                    me.updateViewModel(response.Payload);

                } else {
                    UI.showErrorMessage(response.ErrorMessages);
                }
            })
            .always(() => {
                UI.hideWaitIndicator(this.container, waitContainer);
                deferred.resolve();
            });

        return deferred.promise();
    }

    private isValid(): boolean {
        let isValid: boolean = true;

        if (this.viewModel.TimeZoneID() == null) {
            UI.showErrorMessage([USERPROFILE_MISSING_TIMEZONEID]);
            isValid = false;
        }

        return isValid;
    }

    private updateViewModel(userProfileMaster: UserProfileData.IUserProfileMaster) {
        this.viewModel.TimeZones(userProfileMaster.TimeZones);
        this.viewModel.Languages(userProfileMaster.Languages || []);
        this.viewModel.TimeZoneID(userProfileMaster.TimeZoneID);
        this.viewModel.LanguageID(userProfileMaster.LanguageID);
        this.fieldsOnLoad = JSON.stringify(this.createUserProfileMaster());
    }

    private createUserProfileMaster(): UserProfileData.IUserProfileMaster {
        const UserProfileMaster: UserProfileData.IUserProfileMaster = {
            TimeZoneID: this.viewModel.TimeZoneID(),
            LanguageID: this.viewModel.LanguageID(),
            TimeZones: this.viewModel.TimeZones(),
            Languages: this.viewModel.Languages(),
        };
        return UserProfileMaster;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/controllers/userProfile.ts